import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 29px;
  height: 29px;
  color: ${({ color }: any) => color || '#094994'};
`

const Quicklinks = ({ color, title = 'Quick Links', ...rest }: IconProps & { color?: string }) => (
  <StyledIcon viewBox="0 0 29 29" title={title} {...rest}>
    <g stroke="currentColor" strokeWidth={2} fill="none" fillRule="evenodd" strokeLinecap="square">
      <path d="M13.24 10.58a6.544 6.544 0 013.249 1.794h0a6.679 6.679 0 011.93 4.702 6.679 6.679 0 01-1.93 4.702l-4.237 4.274A6.562 6.562 0 017.592 28c-1.749 0-3.425-.7-4.661-1.948h0A6.679 6.679 0 011 21.351c0-1.764.694-3.455 1.93-4.702l4.238-4.275" />
      <path d="M15.76 18.42a6.544 6.544 0 01-3.249-1.794h0a6.679 6.679 0 01-1.93-4.702c0-1.764.694-3.455 1.93-4.702l4.237-4.274A6.562 6.562 0 0121.408 1c1.749 0 3.425.7 4.661 1.948h0A6.679 6.679 0 0128 7.649a6.679 6.679 0 01-1.93 4.702l-4.238 4.275" />
    </g>
  </StyledIcon>
)

export default Quicklinks
